import React from 'react';
import { FaUserPen } from 'react-icons/fa6';
import { MdSupervisedUserCircle } from 'react-icons/md';
import { TiTags } from 'react-icons/ti';
import { lazyPage } from '../lazyPage';

const RoleManagement = lazyPage(() => import(/* webpackChunkName: "m-platform-admin" */ '../../pages/RoleManagement'));
const AdminManagament = lazyPage(() => import(/* webpackChunkName: "m-platform-admin" */ '../../pages/AdminManagement'));
const Tags = lazyPage(() => import(/* webpackChunkName: "m-platform-admin" */ '../../pages/Tags'));

/**
 * Platform-admin cluster manifests (roles / admins / tags). platformUser_mgmt and
 * user_mgmt moved to features/people (wave-3 IA: person lists live under People).
 */
const adminManifests = [
    {
        id: 'roles',
        featureName: 'role_mgmt',
        permission: 'view',
        routes: [{ path: '/role-management', element: <RoleManagement /> }],
        sidebarItems: [{ text: 'Role Management', icon: <FaUserPen />, link: '/role-management' }],
    },
    {
        id: 'admins',
        featureName: 'admin_mgmt',
        permission: 'view',
        routes: [{ path: '/admin-management', element: <AdminManagament /> }],
        sidebarItems: [{ text: 'Admin Management', icon: <MdSupervisedUserCircle />, link: '/admin-management' }],
    },
    {
        id: 'tags',
        featureName: 'tags_360_mgmt',
        permission: 'view',
        routes: [{ path: '/tags', element: <Tags /> }],
        sidebarItems: [{ text: '360 Tags', icon: <TiTags />, link: '/tags' }],
    },
];

export default adminManifests;
